<template lang="html">
  <div>
      <el-tag
        class="tag-item"
        v-for="(item,inx) in inArr"
        :key="item"
        @close="tagRemove(inx)"
        closable>
        {{item}}
      </el-tag>
      <el-input
        class="tag-input"
        v-if="tagEdit"
        v-model="newTag"
        ref="saveTagInput"
        size="small"
        @keyup.enter.native="goEdit(2)"
        @blur="goEdit(2)"
      >
      </el-input>
      <el-button v-else class="new-tag" size="small" @click="goEdit(1)">+ 新标签</el-button>
  </div>

</template>

<script>
export default {
    name:'tagSelect',
    props:['selectTags','paramsKey'],
    data(){
        return{
            inArr:[],
            tagEdit:false,
            newTag:''
        }
    },
    watch:{
        selectTags:function(e){
            if(e && (e !== this.inArr.join(','))){
                this.inArr = e.split(',');
            }
        },
        inArr:function(e){
            this.$emit('selectChange',{
                id:e.join(','),
                paramsKey:this.paramsKey
            })
        }
    },
    methods:{
        goEdit:function(type){
            if(type == 1){
                this.tagEdit = true;
                this.$nextTick(_ => {
                    this.$refs.saveTagInput.$refs.input.focus();
                });
            }else if(type == 2){
                if(this.newTag){
                    this.inArr.push(this.newTag);
                }
                this.tagEdit = false;
                this.newTag = '';
            }
        },
        tagRemove:function(e){
            this.inArr.splice(e,1);
        }
    }
}
</script>

<style lang="css" scoped>

.tag-item{
    margin-right: 12px;
}

.tag-input{
    width: 80px;
}

</style>



// WEBPACK FOOTER //
// tagSelect.vue?1d72b03e